module.exports = "pegasus/assets/custom-3-facebook.png";